import React from 'react';

import { ReactComponent as ErrorIcon } from '@ihsm/ui-shared/lib/esm/shared/assets/icons/error-icon.svg';

import './NoData.scss';

export const NoData: React.FC = (): JSX.Element => (
  <div className="no-data-wrapper">
    <ErrorIcon />
    <div className="no-data-text">No data available for your selection</div>
  </div>
);
